"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-ui-sdk/Auth/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/Channels/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-ui-sdk/Domains/reducer"));

var _reactRouterRedux = require("react-router-redux");

var _Notifications = _interopRequireDefault(require("ReduxMessenger/reducers/Notifications"));

var _reducer5 = _interopRequireDefault(require("settings-ui-sdk/Hubs/reducer"));

var _reducer6 = _interopRequireDefault(require("settings-ui-sdk/Iris/reducer"));

var _reducer7 = _interopRequireDefault(require("settings-ui-sdk/SiteSettings/reducer"));

var _reducer8 = _interopRequireDefault(require("settings-ui-sdk/Properties/reducer"));

var _reducer9 = _interopRequireDefault(require("settings-ui-sdk/UserAppAttributes/reducer"));

var _reducer10 = _interopRequireDefault(require("settings-ui-sdk/DesignTemplates/reducer"));

var _reducer11 = _interopRequireDefault(require("settings-ui-sdk/PortalSettings/reducer"));

var _reducer12 = _interopRequireDefault(require("settings-ui-sdk/Users/reducer"));

var _reducer13 = _interopRequireDefault(require("settings-ui-sdk/Owners/reducer"));

var _reducer14 = _interopRequireDefault(require("settings-ui-sdk/UserSettings/reducer"));

var _reducer15 = _interopRequireDefault(require("settings-ui-sdk/I18n/reducer"));

var _reducer16 = _interopRequireDefault(require("settings-ui-sdk/SupportedLanguages/reducer"));

var _reducer17 = _interopRequireDefault(require("settings-ui-sdk/OptIn/reducer"));

var _reducer18 = _interopRequireDefault(require("settings-ui-sdk/Sitemaps/reducer"));

var _reducer19 = _interopRequireDefault(require("settings-ui-sdk/PagesForSitemaps/reducer"));

var _reducer20 = _interopRequireDefault(require("settings-ui-sdk/Themes/reducer"));

var _reducer21 = _interopRequireDefault(require("settings-ui-sdk/MultiCurrency/reducer"));

var _reducer22 = _interopRequireDefault(require("settings-ui-sdk/SitePages/reducer"));

var _reducer23 = _interopRequireDefault(require("settings-ui-sdk/Lists/reducer"));

var _GoogleFonts = _interopRequireDefault(require("ContentData/reducers/GoogleFonts"));

var _default = function _default(rootModule) {
  return (0, _redux.combineReducers)({
    auth: _reducer.default,
    channels: _reducer3.default,
    domains: _reducer4.default,
    routing: _reactRouterRedux.routerReducer,
    requests: _reducer2.default,
    notifications: _Notifications.default,
    modules: rootModule.reducer,
    hub: _reducer5.default,
    iris: _reducer6.default,
    designTemplates: _reducer10.default,
    siteSettings: _reducer7.default,
    portalSettings: _reducer11.default,
    multiCurrency: _reducer21.default,
    owners: _reducer13.default,
    users: _reducer12.default,
    userSettings: _reducer14.default,
    userAppAttributes: _reducer9.default,
    languageLocale: _reducer15.default,
    supportedLanguages: _reducer16.default,
    optIn: _reducer17.default,
    properties: _reducer8.default,
    sitemaps: _reducer18.default,
    pagesForSitemaps: _reducer19.default,
    themes: _reducer20.default,
    sitePages: _reducer22.default,
    contactLists: _reducer23.default,
    resources: (0, _redux.combineReducers)({
      googleFonts: _GoogleFonts.default
    })
  });
};

exports.default = _default;
module.exports = exports.default;